import { LaunchpadItem, TaskStatus } from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';

/**
 * Whether a launchpad task should block a gated feature.
 *
 * A task absent from the member's launchpad schema never blocks — schemas vary by user type, so a
 * gate naming a task the member will never be given must not lock them out forever. Both the sidebar
 * lock (useMenuAreas) and the health insurance route guard depend on that rule, so it lives here
 * rather than being re-derived at each call site.
 *
 * Absent-does-not-block only holds for a schema that actually loaded. Callers must reject an empty
 * launchpad separately, since every task reads as absent there and this would clear the member.
 */
export default function isLaunchpadTaskBlocking(launchpadItems?: LaunchpadItem[], taskId?: string): boolean {
    if (!taskId) {
        return false;
    }
    const task = launchpadItems?.find((item) => item.template_id === taskId);
    if (!task) {
        return false;
    }
    return task.status !== TaskStatus.COMPLETED;
}
